// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../node_modules/css-loader/index.js!../../node_modules/postcss-loader/dist/cjs.js!./main.css");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../node_modules/vue-style-loader/lib/addStylesClient.js")("da5e85cc", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./src/styles/main.css
// module id = 987
// module chunks = 0